export default __webpack_public_path__ + "static/media/womenaudiogreen.60ba59f0.png";